._IFrameComponent_13i9y_1 {
  width: 100%;
  border: none;
}